import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input } from '@angular/core';
import { Client } from '@df/core/service/client';

/**
 * Component that toggles images when hovered
 * Needs to be wrapped with a ratiod container
 */
@Component({
    selector: 'product-alt-image',
    templateUrl: './product-alt-image.html',
    styleUrls: ['./product-alt-image.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductAltImageComponent {
    /**
     * Default image
     */
    @Input()
    mainImage?: string;

    @Input({ required: true })
    ratio!: string | number;

    /**
     * Alternative image visible on hover
     */
    @Input()
    altImage?: string;

    /**
     * Alt attribute text
     */
    @Input()
    altText?: string;

    /**
     * Dependencies
     */
    constructor(
        private cd: ChangeDetectorRef,
        private client: Client
    ) {}

    /**
     * Ever hovered
     */
    private hovered = false;

    @HostListener('mouseenter')
    onMouseEnter() {
        if (!this.hovered) {
            this.hovered = true;
            this.cd.detectChanges();
        }
    }

    /**
     * Alternative image is only printed after first time it was needed
     */
    canPrintAltImage(): boolean {
        return !this.client.isTouchy && !!(this.hovered && this.altImage);
    }
}
